import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { resources } from "./resources";

// Initialize i18n if not already initialized
if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "de",
      supportedLngs: ["en", "de"],
      debug: process.env.NODE_ENV === "development",
      ns: [
        "common",
        "documents",
        "audits",
        "auth",
        "sidebar",
        "settings",
        "dashboard",
        "chat",
        "reports",
        "admin",
        "inbox",
        "soa",
      ],
      defaultNS: "common",
      fallbackNS: false,
      resources,
      interpolation: {
        escapeValue: false,
        formatSeparator: ",",
      },
      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
      },
    });
}

// Export utility functions
export const changeLanguage = (lng: string) => {
  return i18n.changeLanguage(lng);
};

export const getCurrentLanguage = () => {
  return i18n.language;
};

export const getSupportedLanguages = () => {
  return ["en", "de"];
};

// Export react-i18next hook for components
export { useTranslation };

// Export i18n instance
export default i18n;
